"use client";

import { useEffect } from "react";

/** Locks document scroll on desktop home so the first screen stays one viewport. */
export default function HomeScrollLock() {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("home-no-scroll");
    return () => root.classList.remove("home-no-scroll");
  }, []);

  return null;
}
